var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var LotteryResultValueConverter = /** @class */ (function () {
    function LotteryResultValueConverter() {
    }
    LotteryResultValueConverter.prototype.toView = function (text, lottery) {
        var e_1, _a;
        var html = "";
        if (!lottery)
            return "<div></div>";
        var regex = /(\d+)/mgi;
        var matches = text ? text.match(regex) : [];
        var drawNumber = 0;
        try {
            for (var matches_1 = __values(matches), matches_1_1 = matches_1.next(); !matches_1_1.done; matches_1_1 = matches_1.next()) {
                var match = matches_1_1.value;
                drawNumber++;
                if (drawNumber <= lottery.feedDrawnNumbers) { // this means its a main number
                    html += "<div class='num'>".concat(match, "</div>");
                }
                else if (lottery.feedDrawnBonusNumbers && drawNumber <= (lottery.feedDrawnNumbers + lottery.feedDrawnBonusNumbers)) { // this means its a bonus number
                    html += "<div class='num bonus'>".concat(match, "</div>");
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (matches_1_1 && !matches_1_1.done && (_a = matches_1.return)) _a.call(matches_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return html;
    };
    return LotteryResultValueConverter;
}());
export { LotteryResultValueConverter };
